






























































































































import { Component, Vue } from "vue-property-decorator";
import LanguagePicker from "@/components/LanguagePicker.vue";
import axios from "axios";
import moment from "moment";
import { authenticationService } from "@/_services";

@Component({
  components: { LanguagePicker },
})
export default class NavBar extends Vue {
  user: null | undefined;
  role: string = "";
  userName: string = "";

  created() {
    authenticationService.currentUser.subscribe((x: null) => {
      this.user = x;
    });
  }

  mounted() {
    // authenticationService.currentUser.subscribe((x: null) => {
    //   this.user = x;
    // });
    // Vue.prototype.$user = localStorage.user;
    // if (localStorage.userName) {
    //   this.userName = localStorage.userName;
    //   this.role = localStorage.role;
    // }
  }

  updated() {
    // Vue.prototype.$user = localStorage.user;
    // if (localStorage.userName) {
    //   this.userName = localStorage.userName;
    //   this.role = localStorage.role;
    // }
  }

  getDate(days = 0) {
    return moment().add(days, "days").format("YYYY-MM-DD");
  }

  getMonday() {
    return moment().day(1).format("YYYY-MM-DD");
  }

  getSunday() {
    return moment().day(7).format("YYYY-MM-DD");
  }

  getNextMonday() {
    return moment().day(1).add(7, "days").format("YYYY-MM-DD");
  }

  getNextSunday() {
    return moment().day(7).add(7, "days").format("YYYY-MM-DD");
  }


  logout() {
    this.userName = "";
    this.role = "";
    delete localStorage.token;
    delete localStorage.user;
    delete localStorage.userName;
    delete localStorage.role;
    delete localStorage.currentUser;
    this.$router.replace("/login");
  }
}
